import Vue from 'vue';
import store from './../../store';

const success = (id, resolve) => {
  store.dispatch('removeOrderProduct', id);
  resolve();
};

const failed = reject => reject();

export default (orderId, orderProductId) => (
  new Promise((resolve, reject) => {
    Vue.$http.delete(`/orders/${orderId}/products/${orderProductId}`)
    .then(() => {
      success(orderProductId, resolve);
    })
    .catch(() => {
      failed(reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/orderProduct/destroy.js